module.exports = __webpack_public_path__ + "static/media/historico_ativo.7f1d9a49.png";